import {Menu as MenuAntd} from 'antd';
import {SelectParam} from 'antd/lib/menu';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {Permission} from '../../utils/auth';
import {getAuthorizedRegions} from '../../utils';

const {Item, SubMenu} = MenuAntd;

export interface MenuProps {
  selectedKeys: Array<string>;
  defaultOpenKeys: Array<string>;
  logoutIfLogoutClicked: (key: SelectParam) => void;
  regions: Array<Region>;
}

const Menu: React.FC<MenuProps> = ({selectedKeys, defaultOpenKeys, logoutIfLogoutClicked, regions}: MenuProps) => {
  return (
    <MenuAntd
      theme="dark"
      mode="inline"
      selectedKeys={selectedKeys}
      defaultOpenKeys={defaultOpenKeys}
      onSelect={(key: SelectParam) => logoutIfLogoutClicked(key)}
    >
      <SubMenu key="ordersHistorySubmenu" title={'Orders history'}>
        {getAuthorizedRegions(regions, Permission.Orders).map((region: Region) => (
          <Item key={`orders-history/${region.id}`}>
            <Link to={`/orders-history/${region.id}`}>{region.name}</Link>
          </Item>
        ))}
      </SubMenu>
      <SubMenu key="membershipsSubmenu" title={'Memberships'}>
        {getAuthorizedRegions(regions, Permission.Memberships).map((region: Region) => (
          <Item key={`memberships/${region.id}`}>
            <Link to={`/memberships/${region.id}`}>{region.name}</Link>
          </Item>
        ))}
      </SubMenu>
      <SubMenu key="starterpacksSubmenu" title={'Starterpacks'}>
        {getAuthorizedRegions(regions, Permission.Memberships).map((region: Region) => (
          <Item key={`starterpacks/${region.id}`}>
            <Link to={`/starterpacks/${region.id}`}>{region.name}</Link>
          </Item>
        ))}
      </SubMenu>
      <SubMenu key="paymentHistorySubmenu" title={'Payment history'}>
        {getAuthorizedRegions(regions, Permission.Orders).map((region: Region) => (
          <Item key={`payment-history/${region.id}`}>
            <Link to={`/payment-history/${region.id}`}>{region.name}</Link>
          </Item>
        ))}
      </SubMenu>
      <SubMenu key="CrmErrorsResponsePage" title={'Form Submission CRM Errors'}>
        {getAuthorizedRegions(regions, Permission.Orders).map((region: Region) => (
          <Item key={`submission-crm-errors/${region.id}`}>
            <Link to={`/submission-crm-errors/${region.id}`}>{region.name}</Link>
          </Item>
        ))}
      </SubMenu>
      <Item key="logOut">
        <b>Log out</b>
      </Item>
    </MenuAntd>
  );
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menu.tsx